import { render, staticRenderFns } from "./list_regions.vue?vue&type=template&id=20df331c&scoped=true&"
import script from "./list_regions.vue?vue&type=script&lang=js&"
export * from "./list_regions.vue?vue&type=script&lang=js&"
import style0 from "./list_regions.vue?vue&type=style&index=0&id=20df331c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df331c",
  null
  
)

export default component.exports